import React, { useState, useEffect, useContext } from "react";
import Accordion from "react-bootstrap/Accordion";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import Card from "react-bootstrap/Card";
import Switch from "react-switch";
import Select from "react-select";
import Modal from "../../../utils/tickets/Modal";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";

const NaturalisationTable = props => {
  const {
    t,
    handleCreationTicketNature,
    ticketNatureItems,
    handleUpdateTicketNature,
    handleDeleteTicketNature
  } = props;

  const [natureState, setNatureState] = useState({
    nature_en: "",
    nature_fr: ""
  });

  const [natureItemsFr, setNatureItemsFr] = useState([]);
  const [natureItemsEn, setNatureItemsEn] = useState([]);
  const [compt, setCompt] = useState(0);

  const [state, setState] = useState({
    //show: false,
    showCreateForm: false,
    title: "",
    openModal: false,
    ticketNatureSelected: null,
    isSelected: false
  });

  const cardStyle = {
    emptyChannel: {
      background: "#ffffff"
    },
    titleContainer: {
      padding: "0 5rem"
    },
    h2: {
      padding: "1.5rem 0",
      fontSize: "2rem"
    },
    card: {
      margin: "0 10px 20px 10px",
      borderBottomLeftRadius: "10px",
      borderBottomRightRadius: "10px",
      borderBottom: "1px solid rgba(200,211,214,1)"
    },
    p: {
      color: "#4c4c4c",
      fontSize: "16px",
      fontWeight: "bold",
      marginBottom: 0
    },
    switch: {
      marginLeft: "10px",
      marginTop: "10px"
    }
  };

  const openModal = item => {
    setState({ ...state, ticketNatureSelected: item, openModal: true });
  };
  //

  const handleTitleChange = event => {
    const { value } = event.currentTarget;
    setState({ ...state, title: value });
  };

  const handleInputChangeFr = (event, item, i) => {
    const { value } = event.currentTarget;
    const clonedItem = { ...item };
    clonedItem["label"] = value;
    const clonedItems = [...natureItemsFr];
    clonedItems[i] = clonedItem;
    setNatureItemsFr(clonedItems);
  };

  const handleInputChangeEn = (event, item, i) => {
    const { value } = event.currentTarget;
    const clonedItem = { ...item };
    clonedItem["label"] = value;
    const clonedItems = [...natureItemsEn];
    clonedItems[i] = clonedItem;
    setNatureItemsFr(clonedItems);
  };

  const handleCloseModalDelete = () => {
    setState({ ...state, openModal: false });
    // console.log(state);
    handleDeleteTicketNature(state.ticketNatureSelected);
  };

  const handleTitleUpdate = (e, item, i) => {
    const { value } = e.currentTarget;
    if (value !== "" && state.initTicketNatureList[i].title !== value)
      handleUpdateTicketNature(value, item.nature, item.id);
  };

  useEffect(() => {
    // console.log("NatureItemsFr : ", natureItemsFr);
    // console.log("NatureItemsEn : ", natureItemsEn);
    if (ticketNatureItems) {
      setNatureItemsFr(ticketNatureItems);
    }
  }, [ticketNatureItems, natureItemsFr, compt]);

  //
  const [natureEnError, setNatureEnError] = React.useState(undefined);
  const [natureFrError, setNatureFrError] = React.useState(undefined);
  const handleNatureEnChange = event => {
    setNatureEnError(undefined);
    const { value } = event.currentTarget;
    setNatureState({ ...natureState, nature_en: value });
  };

  const handleNatureFrChange = event => {
    setNatureFrError(undefined);
    const { value } = event.currentTarget;
    setNatureState({ ...natureState, nature_fr: value });
  };
  React.useEffect(() => {
    setNatureEnError(
      natureItemsFr.filter(
        i => i.labels?.en.toLowerCase() === natureState.nature_en.toLowerCase()
      ).length
        ? "translations.nature_name_not_uniq"
        : undefined
    );
    setNatureFrError(
      natureItemsFr.filter(
        i => i.labels?.fr.toLowerCase() === natureState.nature_fr.toLowerCase()
      ).length
        ? "translations.nature_name_not_uniq"
        : undefined
    );
  }, [natureState]);

  const handleCreateTicketNature = () => {
    if (natureEnError || natureFrError) {
      return false;
    } else {
      const varia = handleCreationTicketNature(
        natureState.nature_en,
        natureState.nature_fr
      );
      setCompt(compt + 1);
      natureState.nature_en = "";
      natureState.nature_fr = "";
    }
  };
  const columns = [
    {
      name: t("settings.naturalisation.ticket_nature_en"),
      cell: row => <div>{row.labels?.["en"]}</div>
    },
    {
      name: t("settings.naturalisation.ticket_nature_fr"),
      cell: row => <div>{row.labels?.["fr"]}</div>
    },
    {
      name: "ACTIONS",
      width: "100px",
      cell: row => (
        <div>
          {row.labels?.["en"] === "General" ? (
            <Button
              disabled={row.labels?.["en"] === "General"}
              variant={"outline-secondary"}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash"
                viewBox="0 0 16 16"
              >
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
              </svg>
            </Button>
          ) : (
            <Button
              disabled={row.labels?.["en"] === "General"}
              variant={"outline-danger"}
              onClick={() => openModal(row)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash"
                viewBox="0 0 16 16"
              >
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
              </svg>
            </Button>
          )}
        </div>
      )
    }
  ];
  return (
    <>
      <div className={""} style={{ padding: "5px 30px" }}>
        {/*<p className="card-header-title" style={cardStyle.p}>*/}
        {/*  {t("settings.naturalisation.ticket_nature")}*/}
        {/*</p>*/}
        <DataTable
          noHeader
          columns={columns}
          data={natureItemsFr}
          highlightOnHover
          pointerOnHover
          pagination
        />
        <div style={{ display: "flex", alignItems: "center", marginTop: 40 }}>
          <div>
            <div className="form-row">
              <div className="form-group col-5">
                <label htmlFor="title">
                  {t("settings.naturalisation.ticket_nature_en")}
                </label>
                <input
                  type="nature"
                  value={natureState.nature_en}
                  onChange={e => handleNatureEnChange(e)}
                  className="form-control form-control-lg"
                  id="nature"
                  autoComplete={"off"}
                  placeholder={t(
                    "settings.naturalisation.enter_ticket_nature_en"
                  )}
                />
                {natureEnError ? (
                  <span className={"text-danger"}>{t(natureEnError)}</span>
                ) : (
                  ""
                )}
              </div>
              <div className="form-group col-5">
                <label htmlFor="title">
                  {t("settings.naturalisation.ticket_nature_fr")}
                </label>
                <input
                  type="nature"
                  value={natureState.nature_fr}
                  onChange={e => handleNatureFrChange(e)}
                  className="form-control form-control-lg"
                  id="nature"
                  autoComplete={"off"}
                  placeholder={t(
                    "settings.naturalisation.enter_ticket_nature_fr"
                  )}
                />
                {natureFrError ? (
                  <span className={"text-danger"}>{t(natureFrError)}</span>
                ) : (
                  ""
                )}
              </div>

              <div className="form-group col-2">
                <button
                  onClick={() => handleCreateTicketNature()}
                  className="btn btn-primary button-add-subject"
                  style={{ width: 200, marginTop: 28, height: 42 }}
                >
                  <span>
                    + &nbsp;&nbsp;&nbsp;&nbsp;{" "}
                    {t("settings.naturalisation.new_ticket_nature")}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Card.Body>
        {/*{natureItemsFr &&*/}
        {/*  natureItemsFr.map((item, i) => (*/}
        {/*    <div className="form-row" key={i}>*/}
        {/*      <div className="form-group col-5">*/}
        {/*        <label htmlFor="title">*/}
        {/*          {t("settings.naturalisation.ticket_nature_en")}*/}
        {/*        </label>*/}
        {/*        <input*/}
        {/*          type="nature"*/}
        {/*          value={natureItemsFr[i].labels?.["en"]}*/}
        {/*          disabled="disabled"*/}
        {/*          onChange={e => handleInputChangeEn(e, item, i)}*/}
        {/*          className="form-control"*/}
        {/*          id="nature"*/}
        {/*          autoComplete={"off"}*/}
        {/*          placeholder={t(*/}
        {/*            "settings.naturalisation.enter_ticket_nature_en"*/}
        {/*          )}*/}
        {/*        />*/}
        {/*      </div>*/}
        {/*      <div className="form-group col-5">*/}
        {/*        <label htmlFor="title">*/}
        {/*          {t("settings.naturalisation.ticket_nature_fr")}*/}
        {/*        </label>*/}
        {/*        <input*/}
        {/*          type="nature"*/}
        {/*          disabled="disabled"*/}
        {/*          value={natureItemsFr[i].labels?.["fr"]}*/}
        {/*          onChange={e => handleInputChangeFr(e, item, i)}*/}
        {/*          className="form-control"*/}
        {/*          id="nature"*/}
        {/*          autoComplete={"off"}*/}
        {/*          placeholder={t(*/}
        {/*            "settings.naturalisation.enter_ticket_nature_fr"*/}
        {/*          )}*/}
        {/*        />*/}
        {/*      </div>*/}

        {/*      <div className="form-group col-2 delete-button">*/}
        {/*        <div*/}
        {/*          onClick={() => openModal(item)}*/}
        {/*          className="col-md-1 btn btn-default"*/}
        {/*        >*/}
        {/*          X*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  ))}*/}

        {/*Start Champ de nouvelle nature */}
        {/*End Champ de nouvelle nature  */}
        {/*
            {ticketSubject &&
              ticketSubject.map((item, i) => (
                <div className="form-row" key={i}>
                  <div className="form-group col-md-7">
                    <label htmlFor="title">
                      {t("settings.auto_priorization.ticket_subject")}
                    </label>
                    <input
                      name={i}
                      type="title"
                      value={ticketSubject[i] && ticketSubject[i].title}
                      onBlur={e => handleTitleUpdate(e, item, i)}
                      onChange={e => handleInputChange(e, item, i)}
                      className="form-control"
                      id={i}
                      autoComplete={"off"}
                      placeholder={t(
                        "settings.auto_priorization.enter_ticket_subject"
                      )}
                    />
                  </div>
                  <div className="form-group col-md-4">
                    <label htmlFor="priority">
                      {t("settings.auto_priorization.select_priority")}
                    </label>
                    <Select
                      options={state.priorityItems}
                      value={formatPriority(ticketSubject[i].priority)}
                      defaultValue={formatPriority(ticketSubject[i].priority)}
                      onChange={e => handlePriorityUpdate(e, item, i)}
                      isSearchable={false}
                      className="select-priority"
                      placeholder={t(
                        "tickets.create_ticket.ticket_priority_input"
                      )}
                      styles={customStyles}
                      theme={theme => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary: "#eee",
                          primary25: "#eee"
                        }
                      })}
                    />
                  </div>
                  <div className="form-group col-md-1 delete-button">
                    <div
                      onClick={() => openModal(item)}
                      className="col-md-1 btn btn-default"
                    >
                      X
                    </div>
                  </div>
                </div>
              ))} */}
      </Card.Body>
      <Modal
        t={t}
        dialogAlertMessage={t("settings.delete_ticket_nature.message")}
        handleClickOpen={state.openModal}
        handleCloseAccepte={() => handleCloseModalDelete()}
        handleClose={() => setState({ ...state, openModal: false })}
      />
    </>
  );
};

export default NaturalisationTable;
